import type { ApiClient } from '../client/api-client';
import type {
  AdminNotificationPage,
  WorkspaceComment,
  WorkspaceNotificationsSummary,
  WorkspaceScope,
  WorkspaceSummary,
  WorkspaceWithdrawalDetails,
  WorkspaceWithdrawalList,
} from '../contracts/workspace';

export function createWorkspaceService(client: ApiClient) {
  return {
    summary: () => client.get<WorkspaceSummary>('/app/v1/admin/workspace/summary'),
    withdrawals: (scope: WorkspaceScope, page = 1, limit = 50) =>
      client.get<WorkspaceWithdrawalList>(
        `/app/v1/admin/workspace/withdrawals?scope=${scope}&page=${page}&limit=${limit}`,
      ),
    details: (id: number | string) =>
      client.get<WorkspaceWithdrawalDetails>(`/app/v1/admin/workspace/withdrawals/${encodeURIComponent(String(id))}`),
    comments: (id: number | string) =>
      client.get<{ data: WorkspaceComment[] }>(`/app/v1/admin/workspace/withdrawals/${encodeURIComponent(String(id))}/comments`),
    addComment: (id: number | string, text: string) =>
      client.post<WorkspaceComment>(`/app/v1/admin/workspace/withdrawals/${encodeURIComponent(String(id))}/comments`, { text }),
    notifications: (query: { before?: string; changedSince?: string; category?: string; unreadOnly?: boolean; limit?: number }) => {
      const search = new URLSearchParams();
      if (query.before) search.set('before', query.before);
      if (query.changedSince) search.set('changedSince', query.changedSince);
      if (query.category) search.set('category', query.category);
      if (query.unreadOnly) search.set('unreadOnly', 'true');
      search.set('limit', String(query.limit ?? 50));
      return client.get<AdminNotificationPage>(`/app/v1/admin/workspace/notifications?${search.toString()}`);
    },
    markRead: () => client.post<WorkspaceNotificationsSummary>('/app/v1/admin/workspace/notifications/read', {}),
  };
}

export type WorkspaceService = ReturnType<typeof createWorkspaceService>;
